<div class="assets-table-view">
  <table class="table table-bordered m-0">
    <thead class="table-head">
      <tr>
        <th scope="col" class="asset-table-view__header w-48px text-center" *ngIf="!isViewMode">
          <img
            [alt]="allOptionsSelected ? 'Deselect All' : 'Select All'"
            [src]="allOptionIcons"
            width="17"
            (click)="onAllOptionsToggle()" />
        </th>
        <th scope="col" class="asset-table-view__header min-w-350px">
          <div class="d-flex items-center justify-content-between">
            {{ 'asset' | translate }}
          </div>
        </th>
        <th scope="col" *ngIf="categories.length > 0" class="asset-table-view__header">
          <div class="d-flex items-center justify-content-between">
            {{ 'Categories' | translate }}
          </div>
        </th>
        <th scope="col" class="asset-table-view__header">
          <div class="d-flex items-center justify-content-between">
            {{ 'Platform' | translate }}
          </div>
        </th>
        <th scope="col" class="asset-table-view__header">
          <div class="d-flex items-center justify-content-between">
            {{ 'funnel' | translate }}
          </div>
        </th>
        <th scope="col" *ngIf="focuses.length > 0" class="asset-table-view__header">
          <div class="d-flex items-center justify-content-between">
            {{ 'focus' | translate }}
          </div>
        </th>
        <th scope="col" class="asset-table-view__header">
          <div class="d-flex items-center justify-content-between">
            {{ 'releaseDate' | translate }}
          </div>
        </th>
        <th scope="col" *ngIf="regions.length > 0" class="asset-table-view__header">
          <div class="d-flex items-center justify-content-between">
            {{ 'Région' | translate }}
          </div>
        </th>
        <th scope="col" *ngIf="agencys.length > 0" class="asset-table-view__header">
          <div class="d-flex items-center justify-content-between">
            {{ 'Agency' | translate }}
          </div>
        </th>
        <th scope="col" class="asset-table-view__header">
          <div class="d-flex items-center justify-content-between">
            {{ 'Product' | translate }}
          </div>
        </th>
        <th scope="col" class="asset-table-view__header">
          <div class="d-flex items-center justify-content-between">
            {{ 'length' | translate }}
          </div>
        </th>
        <th scope="col" *ngIf="types.length > 0" class="asset-table-view__header">
          <div class="d-flex items-center justify-content-between">
            {{ 'type' | translate }}
          </div>
        </th>
        <th scope="col" *ngIf="!isViewMode" class="asset-table-view__header w-48px text-center pe-3">
          <div class="mx-2 align-item-center" [ngClass]="{ 'non-clickable': !this.selectedIds?.length }">
            <div ngbDropdown class="dropdown" container="body" placement="bottom-right" autoClose="true">
              <div class="dropdown-toggle-container" style="position: relative; left: 7px" ngbDropdownToggle>
                <div class="three-dot-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>

              <div ngbDropdownMenu class="dropdown-menu-start arrow_box" aria-labelledby="dropdownMenuLink">
                <div class="col options hover-text">
                  <div class="col pointer p-0 d-flex align-items-center my-3" (click)="toggleHideSelectedAssets()">
                    <img
                      [src]="areAllSelectedHidden ? 'assets/svg/eye-active-asset.svg' : 'assets/svg/eye-hide-asset.svg'"
                      width="14"
                      height="14"
                      alt="Visibility Icon"
                      style="color: #181e39" />
                    <span class="ms-2 f-10 _700 text-uppercase">{{ areAllSelectedHidden ? 'Activate' : 'Hide' }}</span>
                  </div>
                  <!-- Duplicate selected assets button -->
                  <div class="col pointer p-0 d-flex align-items-center my-3" (click)="duplicateSelectedAssets()">
                    <img src="assets/svg/duplicate.svg" width="14" height="14" alt="Duplicate Icon" />
                    <span class="ms-2 f-10 _700 text-uppercase">Duplicate</span>
                  </div>
                  <!-- Delete selected assets button -->
                  <div
                    *ngIf="canDeleteSelectedAssets"
                    class="col pointer p-0 d-flex align-items-center my-3"
                    (click)="deleteSelectedAssets()">
                    <img src="assets/svg/delete.svg" width="14" height="14" alt="Delete Icon" />
                    <span class="ms-2 f-10 _700 text-uppercase">Delete</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container class="table-row" *ngFor="let item of bundle">
        <ng-container *ngIf="!item.hidden">
          <tr
            [draggable]="!isViewMode"
            [class.drag-card]="item.id === draggedCard?.id"
            [class.highlight]="item.id === targetCardId"
            (dragstart)="onDragStart(item)"
            (dragover)="onDragOver($event, item.id)"
            (dragleave)="onDragLeave()"
            (drop)="onDrop(item)"
            (dragend)="onDragEnd()"
            (click)="onRowSelect(item)">
            <td
              *ngIf="!isViewMode"
              [ngClass]="{ disable: item.hidden, 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell text-center bg-white">
              <img [src]="getItemIcon(item)" width="17" (click)="onItemSelect(item)" />
            </td>
            <td
              [ngClass]="{
                disable: item.hidden,
                'bg-initial-false': item.initial === false,
                pointer: forSelection,
                'row-selected': selectedRow?.id === item.id,
              }"
              class="asset-table-view__cell _700">
              <div class="d-flex items-center justify-content-between">
                <div
                  class="d-flex items-center"
                  [class.pointer]="item?.subAsset?.length > 0"
                  (click)="onExpand(item, $event)">
                  <img
                    *ngIf="item?.subAsset?.length > 0; else placeholder"
                    src="assets/svg/expanded.svg"
                    class="{{ item.id === expandedItemId ? 'rotate-0' : 'rotate-270deg' }}" />
                  <ng-template #placeholder>
                    <div class="w-48px"></div>
                  </ng-template>
                  <span class="text-uppercase">{{ item.title || item.detail }}</span>
                </div>
                <div class="d-flex items-center justify-content-end gap-2">
                  <mtm-master-icon />
                  <span class="f-9">Master</span>
                </div>
              </div>
            </td>
            <td
              *ngIf="categories.length > 0"
              [ngClass]="{
                disable: item.hidden,
                'bg-initial-false': item.initial === false,
                pointer: forSelection,
                'row-selected': selectedRow?.id === item.id,
              }"
              class="asset-table-view__cell">
              {{ item.categories?.join(', ') || '-' }}
            </td>
            <td
              [ngClass]="{
                disable: item.hidden,
                'bg-initial-false': item.initial === false,
                pointer: forSelection,
                'row-selected': selectedRow?.id === item.id,
              }"
              class="asset-table-view__cell py-2">
              <div class="d-flex flex-column gap-2">
                <div *ngFor="let b of item.bets" class="d-flex items-center gap-1">
                  <i class="mtm-icon mtm-icon-{{ b?.toLowerCase() }}"></i>
                  <span class="f-11">{{ b }}</span>
                </div>
              </div>
            </td>
            <td
              [ngClass]="{
                disable: item.hidden,
                'bg-initial-false': item.initial === false,
                pointer: forSelection,
                'row-selected': selectedRow?.id === item.id,
              }"
              class="asset-table-view__cell text-uppercase">
              {{ item.funnel }}
            </td>
            <td
              *ngIf="focuses.length > 0"
              [ngClass]="{
                disable: item.hidden,
                'bg-initial-false': item.initial === false,
                pointer: forSelection,
                'row-selected': selectedRow?.id === item.id,
              }"
              class="asset-table-view__cell text-uppercase">
              {{ item.focus }}
            </td>
            <td
              [ngClass]="{
                disable: item.hidden,
                'bg-initial-false': item.initial === false,
                pointer: forSelection,
                'row-selected': selectedRow?.id === item.id,
              }"
              class="asset-table-view__cell text-uppercase text-center"
              >{{ item?.releaseDate ? formatNgbDate(convertToDateObject(item?.releaseDate)) : '-' }}
            </td>
            <td
              *ngIf="regions.length > 0"
              [ngClass]="{
                disable: item.hidden,
                'bg-initial-false': item.initial === false,
                pointer: forSelection,
                'row-selected': selectedRow?.id === item.id,
              }"
              class="asset-table-view__cell text-uppercase">
              {{ item.region || '-' }}
            </td>
            <td
              *ngIf="agencys.length > 0"
              [ngClass]="{
                disable: item.hidden,
                'bg-initial-false': item.initial === false,
                pointer: forSelection,
                'row-selected': selectedRow?.id === item.id,
              }"
              class="asset-table-view__cell text-uppercase">
              {{ item.agency || '-' }}
            </td>
            <td
              [ngClass]="{
                disable: item.hidden,
                'bg-initial-false': item.initial === false,
                pointer: forSelection,
                'row-selected': selectedRow?.id === item.id,
              }"
              class="asset-table-view__cell text-uppercase">
              {{ item.product || '-' }}
            </td>
            <td
              [ngClass]="{
                disable: item.hidden,
                'bg-initial-false': item.initial === false,
                pointer: forSelection,
                'row-selected': selectedRow?.id === item.id,
              }"
              class="asset-table-view__cell text-uppercase">
              <div class="d-flex flex-column gap-2">
                <div *ngFor="let l of item.length">
                  {{ l }}
                </div>
              </div>
            </td>
            <td
              *ngIf="types.length > 0"
              [ngClass]="{
                disable: item.hidden,
                'bg-initial-false': item.initial === false,
                pointer: forSelection,
                'row-selected': selectedRow?.id === item.id,
              }"
              class="asset-table-view__cell text-uppercase">
              {{ item.type }}
            </td>
            <td
              [ngClass]="{ 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell text-center bg-white pe-3"
              *ngIf="!isViewMode">
              <div #dropdownRef="ngbDropdown" ngbDropdown container="body" dropdownClass="custom-dropdown">
                <div ngbDropdownToggle role="button">
                  <img src="/assets/svg/three-dots-icon.svg" />
                </div>
                <div ngbDropdownMenu>
                  <div class="p-2">
                    <div
                      ngbDropdownItem
                      class="d-flex align-items-center gap-2"
                      (click)="openEditAssetModal(item.funnel, item)">
                      <img src="assets/svg/edit.svg" width="14" height="14" alt="Edit Icon" />
                      <span class="ms-2 f-10 _700 text-uppercase">Edit</span>
                    </div>
                    <div
                      ngbDropdownItem
                      class="d-flex align-items-center gap-2"
                      (click)="openEditAssetModal(item.funnel, item)">
                      <img src="assets/svg/add.svg" width="14" height="14" alt="Add Icon" />
                      <span class="ms-2 f-10 _700 text-uppercase">Add Variant</span>
                    </div>
                    <div ngbDropdownItem class="d-flex align-items-center gap-2" (click)="duplicateAsset(item)">
                      <img src="assets/svg/duplicate.svg" width="14" height="14" alt="Duplicate Icon" />
                      <span class="ms-2 f-10 _700 text-uppercase">Duplicate</span>
                    </div>
                    <div ngbDropdownItem class="d-flex align-items-center gap-2" (click)="hideAsset(item)">
                      <img
                        [src]="item.hidden ? 'assets/svg/eye-active-asset.svg' : 'assets/svg/eye-hide-asset.svg'"
                        width="14"
                        height="14"
                        alt="Visibility Icon"
                        style="color: #181e39" />
                      <span class="ms-2 f-10 _700 text-uppercase">{{ item.hidden ? 'Activate' : 'Hide' }}</span>
                    </div>
                    <div
                      *ngIf="
                        !item.hidden && item.initial === false && isCreator(item.createdBy) && !affectedAssets[item.id]
                      "
                      class="dropdown-item d-flex align-items-center gap-2"
                      (click)="deleteAsset(item)">
                      <img src="assets/svg/delete.svg" width="14" height="14" alt="Delete Icon" />
                      <span class="ms-2 f-10 _700 text-uppercase">Delete</span>
                    </div>
                    <div
                      *ngIf="!item.hidden && bundle?.length"
                      class="dropdown-item d-flex align-items-center gap-2"
                      (click)="onMoveToModalOpen(item)">
                      <img src="assets/svg/move.svg" width="14" height="14" alt="Move To Icon" />
                      <span class="ms-2 f-10 _700 text-uppercase">Move To</span>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <ng-container *ngIf="item?.subAsset?.length">
            <tr *ngFor="let v of item.subAsset" [class.d-none]="item.id !== expandedItemId">
              <th
                scope="col"
                [ngClass]="{ 'bg-initial-false': item.initial === false }"
                class="asset-table-view__cell text-center bg-white"
                *ngIf="!isViewMode">
                <img [src]="getTechnicalVariantIcon(item, v)" width="17" (click)="onTechnicalVariantSelect(item, v)" />
              </th>
              <th
                scope="col"
                [ngClass]="{ 'bg-initial-false': item.initial === false }"
                class="asset-table-view__cell _700 bg-white">
                <div class="d-flex items-center justify-content-between">
                  <div class="d-flex items-center">
                    <img src="assets/svg/hierarchical-indent.svg" />
                    <span class="text-uppercase">{{ v.title || v.detail }}</span>
                  </div>
                  <div class="d-flex items-center justify-content-end gap-2">
                    <img src="assets/svg/tech-variant.svg" />
                    <span class="f-9">TECH. VARIANT</span>
                  </div>
                </div>
              </th>
              <td
                [ngClass]="{ 'bg-initial-false': item.initial === false }"
                class="asset-table-view__cell bg-white text-center"
                >{{ '-' }}</td
              >
              <td
                [ngClass]="{ 'bg-initial-false': item.initial === false }"
                class="asset-table-view__cell bg-white py-2">
                <div class="d-flex flex-column gap-2">
                  <div *ngFor="let b of v.bets" class="d-flex items-center gap-1">
                    <i class="mtm-icon mtm-icon-{{ b?.toLowerCase() }}"></i>
                    <span class="f-11">{{ b }}</span>
                  </div>
                </div>
              </td>
              <td
                [ngClass]="{ 'bg-initial-false': item.initial === false }"
                class="asset-table-view__cell bg-white opacity-50 text-uppercase">
                {{ v.funnel || item.funnel }}
              </td>
              <td
                *ngIf="focuses.length > 0"
                [ngClass]="{ 'bg-initial-false': item.initial === false }"
                class="asset-table-view__cell bg-white opacity-50 text-uppercase">
                {{ v.focus || item.focus }}
              </td>
              <td
                [ngClass]="{ 'bg-initial-false': item.initial === false }"
                class="asset-table-view__cell bg-white text-uppercase text-center"
                >{{ v?.releaseDate ? formatNgbDate(convertToDateObject(v?.releaseDate)) : '-' }}
              </td>
              <td
                *ngIf="regions.length > 0"
                [ngClass]="{ 'bg-initial-false': item.initial === false }"
                class="asset-table-view__cell bg-white opacity-50 text-uppercase">
                {{ v.region || item.region || '-' }}
              </td>
              <td
                *ngIf="agencys.length > 0"
                [ngClass]="{ 'bg-initial-false': item.initial === false }"
                class="asset-table-view__cell bg-white opacity-50 text-uppercase">
                {{ v.agency || item.agency || '-' }}
              </td>
              <td
                [ngClass]="{ 'bg-initial-false': item.initial === false }"
                class="asset-table-view__cell bg-white opacity-50 text-uppercase">
                {{ v.product || item.product || '-' }}
              </td>
              <td [ngClass]="{ 'bg-initial-false': item.initial === false }" class="asset-table-view__cell bg-white">
                <div class="d-flex flex-column gap-2 text-uppercase">
                  <div>
                    {{ v.length }}
                  </div>
                </div>
              </td>
              <td
                *ngIf="types.length > 0"
                [ngClass]="{ 'bg-initial-false': item.initial === false }"
                class="asset-table-view__cell bg-white opacity-50 text-uppercase text-center">
                {{ v.type || item.type || '-' }}
              </td>
              <td
                [ngClass]="{ 'bg-initial-false': item.initial === false }"
                class="asset-table-view__cell text-center bg-white pe-3"
                *ngIf="!isViewMode">
                <div #dropdownRef="ngbDropdown" ngbDropdown container="body">
                  <div ngbDropdownToggle role="button">
                    <img src="/assets/svg/three-dots-icon.svg" />
                  </div>
                  <div ngbDropdownMenu>
                    <div class="p-2">
                      <div
                        ngbDropdownItem
                        class="d-flex align-items-center gap-2"
                        (click)="openEditAssetModal(item.funnel, item)">
                        <img src="assets/svg/edit.svg" width="14" height="14" alt="Edit Icon" />
                        <span class="ms-2 f-10 _700 text-uppercase">Edit</span>
                      </div>
                      <div ngbDropdownItem class="d-flex align-items-center gap-2" (click)="duplicateVariant(item, v)">
                        <img src="assets/svg/duplicate.svg" width="14" height="14" alt="Duplicate Icon" />
                        <span class="ms-2 f-10 _700 text-uppercase">Duplicate</span>
                      </div>
                      <div ngbDropdownItem class="d-flex align-items-center gap-2" (click)="deleteVariant(item, v)">
                        <img src="assets/svg/delete.svg" width="14" height="14" alt="Delete Icon" />
                        <span class="ms-2 f-10 _700 text-uppercase">Delete</span>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- This container for hidden assets  -->
      <ng-container class="table-row" *ngFor="let item of bundle">
        <ng-container *ngIf="item.hidden">
          <tr>
            <th
              scope="col"
              [ngClass]="{ disable: item.hidden, 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell text-center bg-white">
              <img [src]="getItemIcon(item)" width="17" (click)="onItemSelect(item)" />
            </th>
            <th
              scope="col"
              [ngClass]="{ disable: item.hidden, 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell _700">
              <div class="d-flex items-center justify-content-between">
                <i
                  class="fa fa-eye-slash"
                  style="position: absolute; font-size: 17px; bottom: 50%; padding-top: 4px"></i>
                <div
                  class="d-flex items-center"
                  [class.pointer]="item?.subAsset?.length > 0"
                  (click)="onExpand(item, $event)">
                  <img
                    *ngIf="item?.subAsset?.length > 0; else placeholder"
                    src="assets/svg/expanded.svg"
                    class="{{ item.id === expandedItemId ? 'rotate-0' : 'rotate-270deg' }} ms-1" />
                  <ng-template #placeholder>
                    <div class="w-48px"></div>
                  </ng-template>
                  <span>{{ item.title || item.detail }}</span>
                </div>
                <div class="d-flex items-center justify-content-end gap-2">
                  <mtm-master-icon />
                  <span class="f-9">Master</span>
                </div>
              </div>
            </th>
            <td
              *ngIf="categories.length > 0"
              [ngClass]="{ disable: item.hidden, 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell">
              {{ item.categories?.join(', ') || '-' }}
            </td>
            <td
              [ngClass]="{ disable: item.hidden, 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell py-2">
              <div class="d-flex flex-column gap-2">
                <div *ngFor="let b of item.bets" class="d-flex items-center gap-1">
                  <i class="mtm-icon mtm-icon-{{ b?.toLowerCase() }}"></i>
                  <span class="f-11">{{ b }}</span>
                </div>
              </div>
            </td>
            <td
              [ngClass]="{ disable: item.hidden, 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell">
              {{ item.funnel }}
            </td>
            <td
              *ngIf="focuses.length > 0"
              [ngClass]="{ disable: item.hidden, 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell">
              {{ item.focus }}
            </td>
            <td
              [ngClass]="{ disable: item.hidden, 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell text-center"
              >{{ item?.releaseDate ? formatNgbDate(convertToDateObject(item?.releaseDate)) : '-' }}</td
            >
            <td
              *ngIf="regions.length > 0"
              [ngClass]="{ 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell bg-white opacity-50 text-uppercase">
              {{ item.region || '-' }}
            </td>
            <td
              *ngIf="agencys.length > 0"
              [ngClass]="{ 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell bg-white opacity-50 text-uppercase">
              {{ item.agency || '-' }}
            </td>
            <td
              [ngClass]="{ 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell bg-white opacity-50 text-uppercase">
              {{ item.product || '-' }}
            </td>
            <td
              [ngClass]="{ disable: item.hidden, 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell">
              <div class="d-flex flex-column gap-2">
                <div *ngFor="let l of item.length">
                  {{ l }}
                </div>
              </div>
            </td>
            <td
              *ngIf="types.length > 0"
              [ngClass]="{ disable: item.hidden, 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell">
              {{ item.type }}
            </td>
            <td
              [ngClass]="{ 'bg-initial-false': item.initial === false }"
              class="asset-table-view__cell text-center bg-white pe-3"
              *ngIf="!isViewMode">
              <div ngbDropdown container="body">
                <div ngbDropdownToggle role="button">
                  <img src="/assets/svg/three-dots-icon.svg" />
                </div>
                <div ngbDropdownMenu>
                  <div class="p-2">
                    <div
                      ngbDropdownItem
                      [ngClass]="{ disable: item.hidden }"
                      class="d-flex align-items-center gap-2"
                      (click)="openEditAssetModal(item.funnel, item)">
                      <img src="assets/svg/edit.svg" width="14" height="14" alt="Edit Icon" />
                      <span class="ms-2 f-10 _700 text-uppercase">Edit</span>
                    </div>
                    <div
                      ngbDropdownItem
                      [ngClass]="{ disable: item.hidden }"
                      class="d-flex align-items-center gap-2"
                      (click)="openEditAssetModal(item.funnel, item)">
                      <img src="assets/svg/add.svg" width="14" height="14" alt="Add Icon" />
                      <span class="ms-2 f-10 _700 text-uppercase">Add Variant</span>
                    </div>
                    <div
                      ngbDropdownItem
                      [ngClass]="{ disable: item.hidden }"
                      class="d-flex align-items-center gap-2"
                      (click)="duplicateAsset(item)">
                      <img src="assets/svg/duplicate.svg" width="14" height="14" alt="Duplicate Icon" />
                      <span class="ms-2 f-10 _700 text-uppercase">Duplicate</span>
                    </div>
                    <div ngbDropdownItem class="d-flex align-items-center gap-2" (click)="hideAsset(item)">
                      <i
                        class="_500 fa"
                        [ngClass]="item.hidden ? 'fa-eye' : 'fa-eye-slash'"
                        [style.color]="'#181E39'"
                        aria-hidden="true"></i>
                      <span class="ms-2 f-10 _700 text-uppercase">{{ item.hidden ? 'Activate' : 'Hide' }}</span>
                    </div>
                    <div
                      [ngClass]="{ disable: item.hidden }"
                      *ngIf="
                        !item.hidden && item.initial === false && isCreator(item.createdBy) && !affectedAssets[item.id]
                      "
                      class="dropdown-item d-flex align-items-center gap-2"
                      (click)="deleteAsset(item)">
                      <img src="assets/svg/delete.svg" width="14" height="14" alt="Delete Icon" />
                      <span class="ms-2 f-10 _700 text-uppercase">Delete</span>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <ng-container *ngIf="item?.subAsset?.length">
            <tr *ngFor="let v of item.subAsset" [class.d-none]="item.id !== expandedItemId">
              <th scope="col" class="asset-table-view__cell text-center bg-white" *ngIf="!isViewMode">
                <img [src]="getTechnicalVariantIcon(item, v)" width="17" (click)="onTechnicalVariantSelect(item, v)" />
              </th>
              <th scope="col" class="asset-table-view__cell _700 bg-white">
                <div class="d-flex items-center justify-content-between">
                  <div class="d-flex items-center">
                    <img src="assets/svg/hierarchical-indent.svg" />
                    <span>{{ v.title || v.detail }}</span>
                  </div>
                  <div class="d-flex items-center justify-content-end gap-2">
                    <img src="assets/svg/tech-variant.svg" />
                    <span class="f-9">TECH. VARIANT</span>
                  </div>
                </div>
              </th>
              <td class="asset-table-view__cell bg-white opacity-50 text-center">
                {{ '-' }}
              </td>
              <td class="asset-table-view__cell bg-white py-2">
                <div class="d-flex flex-column gap-2">
                  <div *ngFor="let b of v.bets" class="d-flex items-center gap-1">
                    <i class="mtm-icon mtm-icon-{{ b?.toLowerCase() }}"></i>
                    <span class="f-11">{{ b }}</span>
                  </div>
                </div>
              </td>
              <td class="asset-table-view__cell bg-white opacity-50">
                {{ v.funnel || item.funnel }}
              </td>
              <td *ngIf="focuses.length > 0" class="asset-table-view__cell bg-white opacity-50">
                {{ v.focus || item.focus }}
              </td>
              <td class="asset-table-view__cell bg-white text-center">{{
                v?.releaseDate ? formatNgbDate(convertToDateObject(v?.releaseDate)) : '-'
              }}</td>
              <td class="asset-table-view__cell bg-white">
                <div *ngIf="features?.length" class="d-flex flex-column gap-2">
                  <div>
                    {{ v.length }}
                  </div>
                </div>
              </td>
              <td *ngIf="types.length > 0" class="asset-table-view__cell bg-white opacity-50 text-center">
                {{ v.type || item.type || '-' }}
              </td>
              <td class="asset-table-view__cell text-center bg-white pe-3" *ngIf="!isViewMode">
                <div ngbDropdown container="body">
                  <div ngbDropdownToggle role="button">
                    <img src="/assets/svg/three-dots-icon.svg" />
                  </div>
                  <div ngbDropdownMenu>
                    <div class="p-2">
                      <div
                        ngbDropdownItem
                        class="d-flex align-items-center gap-2"
                        (click)="openEditAssetModal(item.funnel, item)">
                        <img src="assets/svg/edit.svg" width="14" height="14" alt="Edit Icon" />
                        <span class="ms-2 f-10 _700 text-uppercase">Edit</span>
                      </div>
                      <div ngbDropdownItem class="d-flex align-items-center gap-2" (click)="duplicateVariant(item, v)">
                        <img src="assets/svg/duplicate.svg" width="14" height="14" alt="Duplicate Icon" />
                        <span class="ms-2 f-10 _700 text-uppercase">Duplicate</span>
                      </div>
                      <div ngbDropdownItem class="d-flex align-items-center gap-2" (click)="deleteVariant(item, v)">
                        <img src="assets/svg/delete.svg" width="14" height="14" alt="Delete Icon" />
                        <span class="ms-2 f-10 _700 text-uppercase">Delete</span>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
</div>
